var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45829 2.4165H20.5416C21.1826 2.4165 21.7973 2.67112 22.2505 3.12433C22.7037 3.57754 22.9583 4.19223 22.9583 4.83317V10.8748H6.04163V4.83317C6.04163 4.19223 6.29624 3.57754 6.74945 3.12433C7.20266 2.67112 7.81735 2.4165 8.45829 2.4165ZM22.9583 22.9582C22.9583 23.5991 22.7037 24.2138 22.2505 24.667C21.7973 25.1202 21.1826 25.3748 20.5416 25.3748V26.5832H18.125V25.3748H10.875V26.5832H8.45829V25.3748C7.81735 25.3748 7.20266 25.1202 6.74945 24.667C6.29624 24.2138 6.04163 23.5991 6.04163 22.9582V12.0832H22.9583V22.9582ZM9.66663 6.0415V8.45817H12.0833V6.0415H9.66663ZM9.66663 14.4998V18.1248H12.0833V14.4998H9.66663Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridge);
export default __webpack_public_path__ + "static/media/fridge.9f08c6927a9f9f5f08863189a44acc4d.svg";
export { ForwardRef as ReactComponent };